export default {
  install(Vue, options) {
    Vue.prototype.$clearEmptyParams = obj => {
      let searchFormModel = {};
      for (var variable in obj) {
        if (obj.hasOwnProperty(variable)) {
          switch (true) {
            case typeof obj[variable] === "string" && obj[variable] !== "":
            case typeof obj[variable] === "number":
            case !!(Array.isArray(obj[variable]) && obj[variable].length):
              searchFormModel[variable] = obj[variable];
              break;
            case variable === "totalMoney":
            case variable === "realTotalMoney":
              let { start, end } = obj[variable];
              if (
                !((start === 0 && end === 0) || (start === "" && end === ""))
              ) {
                searchFormModel[variable] = obj[variable];
              }
              break;
            case Object.prototype.toString.call(obj[variable]) ===
              "[object Object]":
              let tempObj = {};
              for (var key in obj[variable]) {
                if (obj[variable].hasOwnProperty(key)) {
                  if (obj[variable][key] !== "") {
                    tempObj[key] = obj[variable][key];
                  }
                }
              }
              if (Object.keys(tempObj).length > 1) {
                searchFormModel[variable] = obj[variable];
              }
              break;
          }
        }
      }
      return searchFormModel;
    };
  }
};



// WEBPACK FOOTER //
// ./src/plugins/clearEmptyParams.js